import React, { useEffect, useState } from 'react';
import api from '../../api/api';

const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Nairobi', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());

export default function ManageBunchingWindow() {
  const [day, setDay] = useState(today());
  const [farm, setFarm] = useState('');
  const [farms, setFarms] = useState([]);
  const [startTime, setStartTime] = useState('08:00');
  const [locked, setLocked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');

  useEffect(() => {
    api.get('core/buncher-targets/', { params: { day } }).then(({ data }) => {
      setFarms(data.farms || []);
      setFarm((current) => current || data.farms?.[0] || '');
    }).catch(() => setNotice('Could not load farm list.'));
  }, [day]);

  useEffect(() => {
    if (!farm || !day) return;
    api.get('core/bunching-day-start/', { params: { day, farm } }).then(({ data }) => {
      setLocked(data.locked);
      if (data.starts_at) setStartTime(new Date(data.starts_at).toLocaleTimeString('en-GB', { timeZone: 'Africa/Nairobi', hour: '2-digit', minute: '2-digit' }));
    }).catch(() => setLocked(false));
  }, [day, farm]);

  const save = async () => {
    setBusy(true); setNotice('');
    try {
      await api.put('core/bunching-day-start/', { day, farm, start_time: startTime });
      setNotice('Bunching window start adjusted. Live totals and reports will use this time.');
    } catch (error) {
      setNotice(error.response?.data?.detail || error.response?.data?.start_time?.[0] || 'Could not adjust start time.');
    } finally { setBusy(false); }
  };

  return <section className="mp-section">
    <div className="mp-section-header"><h2 className="mp-section-title">Bunching window time</h2><p className="mp-section-sub">Adjust a farm’s locked start time. The bunching target covers 7.67 capture hours. The scheduled start–end clock includes lunch and tea breaks. Captures remain open after it ends.</p></div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 18, maxWidth: 900, padding: 24, borderRadius: 18, background: 'linear-gradient(135deg,#fff8fb,#f3f8f4)', border: '1px solid #eadde4' }}>
      <label>Production day<input type="date" value={day} onChange={(e) => { setDay(e.target.value); setLocked(false); }} style={{ display: 'block', width: '100%', padding: 12, marginTop: 8 }} /></label>
      <label>Farm<select value={farm} onChange={(e) => setFarm(e.target.value)} style={{ display: 'block', width: '100%', padding: 12, marginTop: 8 }}>{farms.map((name) => <option key={name}>{name}</option>)}</select></label>
      <label>New bunching start<input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} style={{ display: 'block', width: '100%', padding: 12, marginTop: 8, fontSize: 22 }} /></label>
      <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <strong>{locked ? 'Start time locked · admin adjustment enabled' : 'No start is locked for this farm and day yet'}</strong>
        <button className="mp-btn mp-btn--primary" disabled={busy || !locked || !farm} onClick={save}>{busy ? 'Saving…' : 'Adjust start time'}</button>
      </div>
      {notice && <p role="status" style={{ gridColumn: '1 / -1', margin: 0 }}>{notice}</p>}
    </div>
  </section>;
}
